import gunclubLogoRaw from "@/assets/gunclub-logo.svg?raw";
import communitiesLogoRaw from "@/assets/communities-logo.svg?raw";
import gunclubLogoUrl from "@/assets/gunclub-logo.svg?url";
import communitiesLogoUrl from "@/assets/communities-logo.svg?url";
import { resolveApiBaseUrl } from "@/utils/env";

const GUNCLUB_SVG = gunclubLogoRaw.trim();
const COMMUNITIES_SVG = communitiesLogoRaw.trim();

/**
 * Bootstrap fallback only. Authoritative tenant SVG still comes from
 * /v1/settings; these exact API hosts cover Gunclub when that field is absent.
 */
const GUNCLUB_API_HOSTS = new Set([
  "gunclub.social",
  "www.gunclub.social",
  "app.gunclub.social",
  "api.gunclub.social",
  "demo.gunclub.social",
  "app.local.gunclub.social",
  "gunclub.closedcircuit.io",
]);

/** Hostname from VITE_API_HOST / origin so local UI follows whichever API tenant you're on. */
export function getApiHostname(): string {
  try {
    return new URL(resolveApiBaseUrl()).hostname
      .toLowerCase()
      .replace(/\.$/, "");
  } catch {
    // Never infer API tenant identity from the UI host.
    return "";
  }
}

/** True only for an explicitly known Gunclub API host. */
export function isGunclubHost(hostname: string = getApiHostname()): boolean {
  return GUNCLUB_API_HOSTS.has(hostname.toLowerCase().replace(/\.$/, ""));
}

/** Bundled SVG mark when /v1/settings has no siteLogoSvg. */
export function getBundledBrandLogoSvg(
  hostname: string = getApiHostname(),
): string {
  return isGunclubHost(hostname) ? GUNCLUB_SVG : COMMUNITIES_SVG;
}

/** Prefer API-served brand SVG; otherwise tenant-safe bundled fallback. */
export function resolveBrandLogoSvg(
  apiSvg: string | null | undefined,
  hostname: string = getApiHostname(),
): string {
  const trimmed = apiSvg?.trim();
  if (trimmed) return trimmed;
  return getBundledBrandLogoSvg(hostname);
}

/** Bundled mark URL (e.g. `<img src>`) when no remote logo is configured. */
export function getBundledBrandLogoUrl(
  hostname: string = getApiHostname(),
): string {
  return isGunclubHost(hostname) ? gunclubLogoUrl : communitiesLogoUrl;
}
